import React, { useMemo } from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './BannerContainerStyle.scss';

export interface BannerContainerProps {
  children?: React.ReactNode;
  className?: string;
  showBannerContent?: boolean;
  style?: React.CSSProperties;
  title?: string;
  uid?: string;
  index?: number;
  bannerText?: string;
}

export const BannerContainer = ({
  children,
  className,
  showBannerContent,
  style = {},
  title,
  uid,
  index = 0,
  bannerText = '',
}: BannerContainerProps) => {
  const defaultBannerStyle: React.CSSProperties = { backgroundColor: 'white' };
  const customBannerStyle = useMemo<React.CSSProperties>(
    () => (showBannerContent ? style : defaultBannerStyle),
    [showBannerContent, style]
  );

  return (
    <div
      className={cn(
        'bodySecondary',
        s.newGlobalBannerContainer,
        !bannerText && s.hideBannerText,
        !index && s.globalBannerContainer,
        className
      )}
      style={customBannerStyle}
      data-tile={title}
      data-testid="global_banner"
      data-uid={uid}
    >
      <div className={cn('bodySecondary', s.globalBannerContent)}>
        {showBannerContent && children}
      </div>
    </div>
  );
};

export default BannerContainer;
